module.exports = __webpack_public_path__ + "static/media/age_4.d805d1fb.svg";